import { IBankConnection } from '@/types'

const syncedTime = (connection: IBankConnection) => {
  const time = new Date(connection.lastSyncedAt ?? '').getTime()
  return Number.isNaN(time) ? -Infinity : time
}

// More than one connection can come back marked primary. Only one is shown as the main
// connection: the one synced most recently, since the backend sends no created date to go by.
// A primary with no usable sync time loses to one that has one; a tie goes to the first listed.
export const mainConnection = (connections: IBankConnection[]) =>
  connections
    .filter(connection => connection.isPrimary)
    .reduce<
      IBankConnection | undefined
    >((latest, connection) => (!latest || syncedTime(connection) > syncedTime(latest) ? connection : latest), undefined)

// The main connection goes first; every other connection, primary or not, keeps its order.
export const orderConnections = (connections: IBankConnection[]) => {
  const main = mainConnection(connections)
  return {
    mainId: main?.id,
    ordered: main ? [main, ...connections.filter(connection => connection !== main)] : connections,
  }
}
